import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { setDisplayModal } from "../actions/modal";

import { setCurrentPage } from "../actions/page";

import { Link } from "react-router-dom";
import axios from "axios";
import { ThreeDots } from "svg-loaders-react";
import { GET_BETTING_PROVIDERS } from "../utils/constants";
import bet9ja from "../assets/icons/Bet9ja Logo.svg";
import x9ja from "../assets/images/1xbet.png";
import msport from "../assets/images/msport.png";
import betwise from "../assets/images/betwise.png";
import betway from "../assets/images/betway.png";
import winnersgoldenchance from "../assets/images/winnersgoldenchance.jpg";
import betbaba from "../assets/images/betbaba.jpg";
import accessbet from "../assets/images/accessbet.jpg";
import betland from "../assets/images/betland.jpg";
import livescorebet from "../assets/images/livescorebet.png";
import xbet from "../assets/images/1xbet.png";
import sportybet from "../assets/images/sportybet.jpg";
import lotto from "../assets/images/25lotto.jpg";
import surebet from "../assets/images/surebet.jpg";
import merrybet from "../assets/images/merrybet.png";
import hallabet from "../assets/images/hallabet.jpg";
import greenlotto from "../assets/images/greenlotto.jpg";
import eliestlotto from "../assets/images/eliestlotto.png";
import betking from "../assets/images/betking.jpg";
import nairabet_old from "../assets/images/nairabet_old.png";
import zoomlifestyle from "../assets/images/zoomlifestyle.png";
import bangbet from "../assets/images/bangbet.png";
import allcitybet from "../assets/images/allcitybet.jpg";
import cashtoken from "../assets/images/cashtoken.jpg";
import nairabet from "../assets/icons/Nairabet Logo.svg";
import westernlotto from "../assets/images/western_lotto.png";
import mlotto from "../assets/images/mlotto.webp";
import cloudbet from "../assets/icons/cloudbet.jpg";
import betting from "../assets/images/football.svg";

import styles from "./BettingPayment.module.scss";

export const BettingPayment = ({ changeCurrentPage, displayModal }) => {
  // console.log('1234');
  const [loading, setLoading] = useState(true);
  const [bettingProviders, setBettingProviders] = useState([]);
  useEffect(() => {
    changeCurrentPage({
      heading: "Betting Payment",
      search: true,
    });
  }, [changeCurrentPage]);

  useEffect(() => {
    let isCancelled = false;

    (async function fetchBettingProviders() {
      try {
        const res = await axios.get(GET_BETTING_PROVIDERS);

        if (!isCancelled) {
          setBettingProviders(res.data.data);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      isCancelled = true;
    };
  }, []);

  // image srcs
  const providerImages = {
    Bet9ja: bet9ja,
    ZoomLifeStyle: zoomlifestyle,
    CashToken: cashtoken,
    MLotto: mlotto,
    WesternLotto: westernlotto,
    AllCityBet: allcitybet,
    BangBet: bangbet,
    NairaBet_old: nairabet_old,
    BetKing: betking,
    GreenLotto: greenlotto,
    EliestLotto: eliestlotto,
    HALLABET: hallabet,
    BetWay: betway,
    MerryBet: merrybet,
    SureBet: surebet,
    '25Lotto': lotto,
    SportyBet: sportybet,
    '1xbet': xbet,
    livescorebet: livescorebet,
    Betland: betland,
    Cloudbet: cloudbet,
    AccessBet: accessbet,
    Nairabet: nairabet,
    BetBaba: betbaba,
    "Winners Golden Chance": winnersgoldenchance,
    Betwize: betwise,
    MSport: msport,
    FootballCom: betting,
  };
  

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.card}>
          <h3 className={styles.sectionHeading}>Betting Providers</h3>
          {!loading && bettingProviders ? (
            <div className={styles.services}>
              {/* <Link to="/betting/cloudbet" className={styles.service}>
                <img className={styles.serviceLogo} src={cloudbet} alt="" />
                <p className={styles.serviceText}>Cloudbet</p>
              </Link> */}
              {bettingProviders.map((provider, index) => {
                const providerName = provider.name;

                if (providerName !== "cloudbet") {
                  return (
                    <div
                      // to={`/betting/${providerName}`}
                      key={index}
                      onClick={() => {
                        displayModal({
                          overlay: true,
                          modal: 'betting',
                          service: providerName,
                        });
                      }}
                      className={styles.service}
                    >
                      <img
                        className={styles.serviceLogo}
                        src={providerImages[providerName] || betting}
                        alt=""
                      />
                      <p className={styles.serviceText}>{providerName}</p>
                    </div>
                  );
                }
              })}
            </div>
          ) : loading ? (
            <ThreeDots fill="#3E215B" />
          ) : (
            <div>Nothing to display</div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeCurrentPage: (payload) => dispatch(setCurrentPage(payload)),
    displayModal: (payload) => dispatch(setDisplayModal(payload)),
  };
};

export default connect(undefined, mapDispatchToProps)(BettingPayment);
